import React from "react";
import "./index.css";
import App from "./App";
// import * as serviceWorker from "./serviceWorker";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { BrowserRouter } from "react-router-dom";
import TagManager from "react-gtm-module";
import "./styles/styles.css";
import "./styles/bootstrap-overwrites.css";
import "leaflet/dist/leaflet.css";
import "react-day-picker/style.css";
import "react-toastify/dist/ReactToastify.css";
import config from "./configurations";
import { createRoot } from "react-dom/client";
const { GTM_KEY } = config;

const tagManagerArgs = {
  gtmId: GTM_KEY,
};

TagManager.initialize(tagManagerArgs);
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register();
